// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { copilotApi } from '@shared/data-access/api-base/citec-copilot-api';
import { type UserParam } from '@shared/data-access/interfaces/api/commons';
import {
  type ChatIntent,
  type Intent,
  type Chat,
  type ChatMessage,
} from '@shared/data-access/interfaces/api/copilot/chat';

export const chatApi = copilotApi.injectEndpoints({
  endpoints: build => ({
    chat: build.mutation<ChatMessage, Chat & UserParam>({
      query: ({ buffer_conversation, chat_context, ...params }) => ({
        url: '/chat/citec/',
        method: 'POST',
        body: {
          buffer_conversation,
          chat_context,
        },
        params: params,
      }),
    }),

    chatIntent: build.mutation<Intent, ChatIntent & UserParam>({
      query: ({ messages, ...params }) => ({
        url: '/chat/citec/intent/',
        method: 'POST',
        body: {
          messages,
        },
        params: params,
      }),
    }),

    chatAgent: build.mutation<ChatMessage, Chat & UserParam>({
      query: ({ buffer_conversation, chat_context, ...params }) => ({
        url: '/chat/citec/agent/',
        method: 'POST',
        body: {
          buffer_conversation,
          chat_context,
        },
        params: params,
      }),
    }),
  }),
});
